export default __webpack_public_path__ + "static/starbucks-ee51921492e90c31c6e7aef165a4eaf5.svg";